<template> 
  <scroll-bar>
    <div style="width: 100%; text-align:center; margin-top: 20px;">
      <router-link to="/">
        <img :src="logourl" style="width:100px;" /> 
      </router-link>
    </div>   
    <div style="width: 100%; text-align:center; margin: 20px 2px 0 2px;">
      <!-- 使用v-html指令渲染包含<br>标签的标题 -->
      <span 
        style="font-size: 18px;letter-spacing: 2px;font-weight:bold; color: #fff;" 
        v-html="formattedTitle"
      ></span>
    </div>  
    <div style="margin: 10px;width: 100%; text-align:center;">
      <hr />
    </div> 
    
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#0063b1"
      text-color="#fff"
      active-text-color="#eea60a"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar> 
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'
import logo_icon from '@/assets/images/logo.png' 
import { isMenus } from "@/utils/auth";
 
export default {    
  data() {
    return {
      menutitle: process.env.BASE_TITLE, // 原始标题
      logourl: logo_icon
    }
  },
  computed: {
    // 计算属性：将标题转换为包含<br>标签的HTML
    formattedTitle() {
      // 在"金岸"和"空调"之间插入<br>标签
      return this.menutitle.replace('金岸空调', '金岸<br>空调');
    },
    ...mapGetters(['menus', 'sidebar', 'routers']),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  components: { SidebarItem, ScrollBar },
  methods: {
    getMenus(m) {
      return isMenus(m, this.menus);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue